import React from 'react';
import { Image } from 'antd';
import { MunchedImage, MunchedImageProxySize } from 'sb-lib/types';
import { useAppSelector } from 'shared/store';
import { getImageMuncherProxySrc } from 'shared/utils/images';
import './style.less';
import clsx from 'clsx';

type SessionChatImageProps =
  | { image: MunchedImage; mode?: string }
  | { image: { id: string }; mode?: string };

export const SessionChatImage: React.FC<SessionChatImageProps> = ({
  image,
  mode = 'light',
}) => {
  const {
    chatImageUploadId,
    chatImageUploadDataUrl,
    chatImageUploadProgress,
  } = useAppSelector(s => s.chat);
  const isBeingUploaded = chatImageUploadId === image.id;

  const transition =
    chatImageUploadProgress > 0 && chatImageUploadProgress < 1
      ? 'width 200ms'
      : 'opacity 1000ms';
  const opacity =
    !isBeingUploaded || chatImageUploadProgress === 0 || chatImageUploadProgress === 1
      ? 0
      : 1;

  const imgSrc =
    isBeingUploaded && chatImageUploadDataUrl
      ? chatImageUploadDataUrl
      : getImageMuncherProxySrc(
          'proxies' in image ? image : null,
          MunchedImageProxySize.large,
          '',
        );

  const status = isBeingUploaded
    ? chatImageUploadProgress < 1
      ? 'Sending...'
      : 'Uploaded'
    : '';

  return (
    <div className="SessionChatImage">
      <div
        className="SessionChatImage__progress"
        style={{
          width: `${100 * chatImageUploadProgress}%`,
          transition,
          opacity,
        }}
      ></div>

      <Image src={imgSrc} />

      {!!status && (
        <div className={clsx('SessionChatImage__status', mode === 'dark' && 'darkMode')}>
          {status}
        </div>
      )}
    </div>
  );
};
